import { render, staticRenderFns } from "./notifyItem.vue?vue&type=template&id=3f8742ef&scoped=true&"
import script from "./notifyItem.vue?vue&type=script&lang=js&"
export * from "./notifyItem.vue?vue&type=script&lang=js&"
import style0 from "./notifyItem.vue?vue&type=style&index=0&id=3f8742ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8742ef",
  null
  
)

export default component.exports